import { makeObservable, action } from "mobx";
import { User } from '../api';
import pako from 'pako';

export default class UserStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      createUser: action,
      getUserById: action,
      getUserByEmail: action,
      getUsers: action,
      updateUserById: action,
      updatePassword: action,
      syncData: action,
      updateUserByEmail: action,
      addProfile: action
    });
  }

  async createUser(data) {
    try {
      const retObj = await User.createUser(data);
      return retObj.data.response.user;
    } catch (error) {
      console.error('Error in createUser:', error);
      throw error;
    }
  }

  async getUserById(id) {
    try {
      const retObj = await User.getUserById(id);
      return retObj.data.response.user;
    } catch (error) {
      console.error('Error in getUserById:', error);
      throw error;
    }
  }

  async getUserByEmail(email) {
    try {
      const retObj = await User.getUserByEmail(email);
      return retObj.data.user;
    } catch (error) {
      console.error('Error in getUserByEmail:', error);
      throw error;
    }
  }

  async getUsers(lastId, type, navId, lookupStrng) {
    try {
      let response={} 
      if (lastId !==''){
        response = await User.getUsers(lastId, type , navId, lookupStrng);
      }else{
        response = await User.getUsers('', type, '', lookupStrng);
      }

      return response && response.data && response.data.response ? response.data.response : 'error';
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  }

  async updateUserById(id, data) {
    try {
      const retObj = await User.updateUserById(id, data);
      return retObj.data.response.user;
    } catch (error) {
      console.error('Error in updateUserById:', error);
      throw error;
    }
  }

  async updatePassword(email, password) {
    try {
      const retObj = await User.updatePassword(email, password);
      return retObj.data.response.user;
    } catch (error) {
      console.error('Error in updatePassword:', error);
      throw error;
    }
  }

  async syncData() {
    try {
      const retObj = await User.syncData();
      return retObj.data.value;
    } catch (error) {
      console.error('Error in syncData:', error);
      throw error;
    }
  }

  async updateUserByEmail(data, email) {
    try {
      const retObj = await User.updateUserByEmail(data, email);
      return retObj.data.response.user;
    } catch (error) {
      console.error('Error in updateUserByEmail:', error);
      throw error;
    }
  }

  async addProfile() {
    try {
      const retObj = await User.addProfile();
      return retObj.data.response.profile;
    } catch (error) {
      console.error('Error in addProfile:', error);
      throw error;
    }
  }
}
